/* ── Bad Bunzy FAQ — bb-faq.js ── */

(function () {
  'use strict';

  // ── FAQ ACCORDION ──
  function initAccordion() {
    document.addEventListener('click', function (e) {

      // Category tab click → scroll to section
      var tab = e.target.closest('.bbfaq-cat-tab');
      if (tab) {
        var sectionId = tab.getAttribute('data-section');
        if (sectionId) {
          var target = document.getElementById(sectionId);
          if (target) target.scrollIntoView({ behavior: 'smooth' });
          document.querySelectorAll('.bbfaq-cat-tab').forEach(function (t) {
            t.classList.remove('active');
          });
          tab.classList.add('active');
        }
        return;
      }

      // FAQ question toggle
      var btn = e.target.closest('.bbfaq-q-btn');
      if (!btn) return;

      var answer = btn.nextElementSibling;
      var isOpen = btn.classList.contains('open');

      // Close all within this category
      var cat = btn.closest('.bbfaq-cat');
      if (cat) {
        cat.querySelectorAll('.bbfaq-q-btn').forEach(function (b) {
          b.classList.remove('open');
          var tog = b.querySelector('.bbfaq-toggle');
          if (tog) tog.textContent = '+';
          if (b.nextElementSibling) b.nextElementSibling.classList.remove('open');
        });
      }

      if (!isOpen && answer) {
        btn.classList.add('open');
        var toggle = btn.querySelector('.bbfaq-toggle');
        if (toggle) toggle.textContent = '×';
        answer.classList.add('open');
      }
    });
  }

  // ── SEARCH ──
  function initSearch() {
    var searchInput = document.querySelector('.bbfaq-search');
    if (!searchInput) return;

    searchInput.addEventListener('input', function () {
      var q = this.value.toLowerCase().trim();

      if (!q) {
        document.querySelectorAll('.bbfaq-item').forEach(function (i) {
          i.style.display = '';
        });
        document.querySelectorAll('.bbfaq-cat').forEach(function (c) {
          c.style.display = '';
        });
        return;
      }

      document.querySelectorAll('.bbfaq-cat').forEach(function (cat) {
        var visible = 0;
        cat.querySelectorAll('.bbfaq-item').forEach(function (item) {
          if (item.textContent.toLowerCase().includes(q)) {
            item.style.display = '';
            visible++;
          } else {
            item.style.display = 'none';
          }
        });
        cat.style.display = visible > 0 ? '' : 'none';
      });
    });
  }

  // ── SCROLL SPY (sidebar + tab active states) ──
  function initScrollSpy() {
    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;

          // Update sidebar links
          document.querySelectorAll('.bbfaq-sidebar-links a').forEach(function (a) {
            a.classList.toggle('active', a.getAttribute('href') === '#' + id);
          });

          // Update category tabs
          document.querySelectorAll('.bbfaq-cat-tab').forEach(function (tab) {
            tab.classList.toggle('active', tab.getAttribute('data-section') === id);
          });
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });

    document.querySelectorAll('.bbfaq-cat').forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordion();
      initSearch();
      initScrollSpy();
    });
  } else {
    initAccordion();
    initSearch();
    initScrollSpy();
  }
})();
